import React from 'react';
import { useAddTrainingActivityTypeComponent } from './useAddTrainingActivityTypeComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import AppFormTextField from '../../../../components/designe/app-form-text-field';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddTrainingActivityType.styles';
import theme from '../../../../styles/theme';
import { ITrainingActivityType } from '../../../../types/interfaces/training-activity-type';

interface IAddTrainingActivityTypeProps {
  trainingActivityType: ITrainingActivityType;
  onClose: () => void;
}

export default function AddTrainingActivityType(
  props: IAddTrainingActivityTypeProps,
) {
  const { trainingActivityType, onClose } = props;
  const { t } = useTranslation();
  const { formik, isLoading } = useAddTrainingActivityTypeComponent(
    onClose,
    trainingActivityType,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.nameKey')}
              fullWidth
              name="nameKey"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.met')}
              fullWidth
              type="number"
              name="met"
              formik={formik}
              inputProps={{ min: 0, step: 'any' }}
            />
          </Grid>
          <Grid item sm={12}>
            <FormControlLabel
              control={
                <Checkbox
                  name="isDefault"
                  checked={formik.values.isDefault}
                  onChange={(e) =>
                    formik.setFieldValue('isDefault', e.target.checked)
                  }
                />
              }
              label={t('common.default')}
            />
          </Grid>
        </Grid>
        <Box className={classes.addTrainingActivityTypeButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {trainingActivityType ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
